( ( $ ) => {

	const $kitSections = $( '[data-ml-load="save-with-kits"]' );
	const ajax_url = window.WPShopify.ajax_url;

	$kitSections.each( ( index, el ) => {
		// console.log( el );
		const $el = $( el );
		// const productType = $el.attr( 'data-product-type' );
		const notId = $el.attr( 'data-not-id' );

		const parts = ( new Date() ).toISOString().split( ':' );
		const cache_key = parts[0];//+ parts[1]; // cut seconds and miliseconds. we have it cached for hour.
		let url = `${ ajax_url }?action=load_save_with_kits&cache=${ cache_key }`;
		// if ( notId ) {
		// 	url = `${ url }&not=${ notId }`;
		// }

		$.ajax(
			{
				'url': url,
				'method': 'get',
				'success': function ( response ) {
					if ( response ) {
						if ( response.data ) {
							$el.slideUp( 0 );
							$el.html( response.data );
							$el.slideDown( 300 );
							// lets remove unnecessary item.
							$el.find( `[data-product-id="${ notId }"]` ).remove();
							const $slider = $el.find( '[data-kits-slider]' );

							// lets randomize slides every page load.
							$slider.children( '[data-product-id]' ).sort( () => {
								return Math.round( Math.random() ) - 0.5;
							} ).detach().appendTo( $slider );

							$slider.slick( {
								slidesToShow: 2,
								slidesToScroll: 1,
								responsive: [
									{
										breakpoint: 1200,
										settings: {
											slidesToShow: 2,
											dots: false,
											arrows: true,
										}

									},
									{
										breakpoint: 768,
										settings: {
											slidesToShow: 1,
											dots: false,
											arrows: true,
										}
									},
									{
										breakpoint: 576,
										settings: {
											slidesToShow: 1,
											dots: false,
											arrows: true,
										}
									}
								]
							} );

							$( document ).trigger( 'wpshopify.block_loaded', [ el ] );

						}
					}
				}
			}
		);

	} );

} )( jQuery )